import MuiDivider from "@mui/material/Divider";

export default function Divider(props) {
  return <MuiDivider {...props} />;
}
